import React from 'react'
import { ArrowDownRightIcon, ArrowUpRightIcon } from 'lucide-react'

import { Badge } from '@/shared/components/ui/badge'
import { formatNumber, NumberFormats } from '@/shared/tools/locale'

export default function PercentDifferenceBadge({ value }: { value: number }) {
	if (Number.isNaN(value)) {
		return null
	}
	if (value > 0) {
		return (
			<Badge variant='success' size='sm'>
				<ArrowUpRightIcon />
				{formatNumber(value, NumberFormats.Percent)}
			</Badge>
		)
	}
	if (value < 0) {
		return (
			<Badge variant='destructive' size='sm'>
				<ArrowDownRightIcon />
				{formatNumber(value, NumberFormats.Percent)}
			</Badge>
		)
	}

	return <Badge>{formatNumber(value, NumberFormats.Percent)}</Badge>
}
